import { useGetGuidParam } from '@risksmart-app/components/src/routes/routes.utils';
import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import { useTranslation } from 'react-i18next';
import { ObjectToolbar } from 'src/blocks/object-toolbar';
import ControlledTabs from 'src/components/controlled-tabs';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import useTabs from '@/hooks/useTabs';
import { riskDetailsUrl } from '@/utils/urls';

import PageLayout from '../../../../layouts/PageLayout';

const Page = () => {
  const riskId = useGetGuidParam('riskId');
  const objectToolbarEnabled = useIsFeatureFlagEnabled('object_toolbar');
  const tabs = useTabs({
    parentType: Parent_Type_Enum.Appetite,
    parent: null,
    hrefRoot: `${riskDetailsUrl(riskId)}/appetite/add`,
  });
  const { t: st } = useTranslation(['common'], { keyPrefix: 'appetites' });
  const title = st('create_modal_title');

  return (
    <PageLayout
      title={title}
      // Object-level toolbar (CUS-159) — flag-gated, title-only. The create form
      // keeps its own Create/Cancel buttons, so no save disc / actions here.
      headerOverride={
        objectToolbarEnabled ? (
          <ObjectToolbar config={{ header: { title } }} />
        ) : undefined
      }
    >
      <ControlledTabs
        tabs={tabs}
        variant={'container'}
        parentType={Parent_Type_Enum.Appetite}
        disableSettings
      />
    </PageLayout>
  );
};

export default Page;
